import Filter from './filter';
import FiltersMapbox from './filtersMapbox';
import LoadResults from '../classes/loadResults';

export default class SearchPage {
    constructor() {
        if(document.getElementsByClassName('search-page')[0]) {
            new Filter();
            const filtersMapbox = new FiltersMapbox();
            new LoadResults(filtersMapbox.map);
        }
    }
}
